// extracted by mini-css-extract-plugin
module.exports = {"root":"form-field_root__j_38K","validation":"form-field_validation__YLuxe","asterisk":"form-field_asterisk__Iz9ZN","labelWrapper":"form-field_labelWrapper__Bv9SV"};